export default {
  not_localised: 'Dieses Dokument ist für deine Region noch nicht verfügbar. Wir zeigen dir die englische Version.',
};
